export default "__VITE_ASSET__Dlex19SM__"